import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import heroImg from "./../../images/demo/home-hero-right.jpeg";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { CARDS_REFERENCE } from "./../cards/show_property_cards_config";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";

import Header, {
  LogoLink,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink,
} from "../headers/light.js";
import {
  LinkObject,
  LINK_REFERENCES,
  SHOW_BACKGROUND_WITHOUT_OPACITY,
} from "./hero_config";

const StyledHeader = styled(Header)`
  ${tw`justify-between`}
  ${LogoLink} {
    ${tw`mr-8 pb-0 grow z-10`}
  }
`;

const NavLink = tw(NavLinkBase)`
  sm:text-sm sm:mx-6 
`;
/**https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80 */
const Container = tw.div`relative -mx-8 -mt-8 `;
const TwoColumn = tw.div`flex justify-between flex-col lg:flex-row lg:items-stretch items-center bg-gray-100`;
const LeftColumn = tw.div`ml-8 mr-8 w-[80%] lg:w-[70%] py-8 grow `;
const PrimaryButton2 = tw(PrimaryButtonBase)`sm:text-lg rounded-none rounded z-10`;
const RightColumn = styled.div`
  background-image: url("${heroImg}");
  width: 100%;
  position: ${SHOW_BACKGROUND_WITHOUT_OPACITY ? "relative" : "absolute"};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: ${SHOW_BACKGROUND_WITHOUT_OPACITY ? "400px" : "100%"};
  filter: blur(${SHOW_BACKGROUND_WITHOUT_OPACITY ? 0 : 4}px);
  opacity: ${SHOW_BACKGROUND_WITHOUT_OPACITY ? 1 : 0.55}; 
  ${tw`bg-green-500 lg:clip-path-heroImgPolygon lg:blur-none lg:opacity-100 lg:relative bg-cover bg-center lg:h-auto lg:w-1/2`}
`;
const Overlay = styled.div`${tw`lg:hidden bg-primary-900 h-[100%] w-[100%] opacity-75`}`

const Content = tw.div`mt-24 lg:mt-24  lg:mb-16 flex flex-col sm:items-center lg:items-stretch`;
const Heading = tw.h1`text-3xl z-[9] text-white lg:text-secondary-600 sm:text-5xl md:text-6xl lg:text-5xl font-black leading-none`;
const Paragraph = tw.p`lg:max-w-[80%] text-white lg:text-secondary-600 z-30 my-8 lg:my-5 lg:my-8 sm:text-lg lg:text-base xl:text-lg leading-loose`;

export default ({
  heading = (
    <>
      <span tw="text-primary-100">A fractionalized</span>
      <br />
      <span tw="text-primary-500">real estate marketplace.</span>
    </>
  ),
  description = `Mulkinvest makes it easy, convenient and fast for investors to invest in curated real estate projects and assets. 

  Mulkinvest members have instant access to view all properties and projects that we offer and can obtain fractional ownership of real estate seamlessly with our experienced team and technology-driven process. All documents needed for your investment due diligence are available on the
  
  We believe every investor should have access to high quality real estate assets and projects. Mulkinvest Allows everyone the opportunity to create a real estate portfolio.`,
}) => {
  const navigate = useNavigate();
  const check = useSelector((state) => state.auth.check);

  const navLinks = [
    <NavLinks key={1}>
      <NavLink>
        <AnchorLink href="#submitProperty">
          {LINK_REFERENCES[0].label}
        </AnchorLink>
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <NavLink >
        <AnchorLink href="#contactUs">{LINK_REFERENCES[1].label}</AnchorLink>
      </NavLink>
    </NavLinks>,
    <NavLinks key={0}>
      <Link to={check ? "/profile" : "/login"} tw="sm:text-sm sm:mx-6">
        <PrimaryLink>{check ? "Profile" : "Login"}</PrimaryLink>
      </Link>
    </NavLinks>,
  ];

  return (
    <Container>
      <TwoColumn>
        <LeftColumn>
          <StyledHeader links={navLinks} collapseBreakpointClass="sm" />
          <Content>
            <Heading>{heading}</Heading>
            <Paragraph>{description}</Paragraph>
          </Content>
          <PrimaryButton2
            onClick={() => navigate("/all-list", { state: CARDS_REFERENCE })}
          >
            {LINK_REFERENCES[2].label}
          </PrimaryButton2>
        </LeftColumn>
        <RightColumn><Overlay>&nbsp;</Overlay></RightColumn>
      </TwoColumn>
    </Container>
  );
};
